import { Box, styled } from '@mui/material';
import { ButtonIcon } from 'components/mrp/mrp.styles';

export const StyledHeader = styled(Box, {
  shouldForwardProp: (propName) => propName !== 'appointmentFormIsOpen'
})<{ appointmentFormIsOpen?: boolean }>(({ theme, appointmentFormIsOpen }) => ({
  display: 'grid',
  gridTemplateColumns: `1fr auto ${appointmentFormIsOpen ? '1fr' : ''}`,
  height: '40px',
  marginRight: theme.spacing(2)
}));

export const ActionsContainer = styled(Box, {
  shouldForwardProp: (prop: string) =>
    !['start', 'end', 'center'].includes(prop)
})<{ start?: boolean; end?: boolean; center?: boolean }>(
  ({ theme, start, end, center }) => ({
    display: 'flex',
    justifyContent: start
      ? 'flex-start'
      : end
      ? 'flex-end'
      : center
      ? 'center'
      : 'inherit',
    alignItems: 'center',
    gap: theme.spacing(2),
    height: '100%'
  })
);

export const ActionButton = styled(ButtonIcon)(({ theme }) => ({
  color: theme.palette.text.primary
}));
